import { getSiJobDetail } from '@/api/SeaImport/siBooking'
import { getReJobDetail } from '@/api/railwayExport/reBooking'
import { cacheName, cache } from '@/utils/cacheManager'
import { batchUpdateChargeState, batchUpdateAccountingDate, batchUpdateChargeAccountingDate } from '@/api/clearing/financeManage'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { Assert } from '@/utils/validate'
import { Job } from '@/class/model/booking/Job'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import * as ImportConstants from '@/class/cargo/model/parameters/ImportConstants'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import AbstractClosingAccount from '@/views/cargo/v0/Clearing/components/ClosingAccount/AbstractClosingAccount'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default class CADetailHp extends AbstractClosingAccount {
  _sapChargeList = []

  get sapChargeList() {
    return this._sapChargeList
  }

  set sapChargeList(value) {
    this._sapChargeList = value
  }

  constructor(view) {
    super(view)
    // this.seContext = new SeContext(new SeParentContext())
  }

  // getSeContext() {
  //   return new SeContext(new SeParentContext())
  // }
  async getAndSetJobDetail() {
    // 因海出页签的内部特殊性，海出单独处理
    if (this._view.lob === 'SE') {
      const seJob = { uuid: this._view.jobUuid }
      await new SeaExportJob(seJob).loadJobRelated({
        job: true,
        seaEQ: true,
        lclSlaves: this._view.masterFlag,
        charges: this._view.masterFlag,
        warehouseIn: this._view.masterFlag,
        warehouseInfo: true,
        trucking: true,
        lclMaster: !this._view.masterFlag,
        seaCargoDoc: !this._view.masterFlag,
        containerUsages: true,
        containers: true,
        cargoBulkDetail: !this._view.masterFlag,
        surchargeTerms: !this._view.masterFlag
      })
      this._view.job = seJob
      return
    }
    if (this._view.lob === 'SI') {
      const siJob = { uuid: this._view.jobUuid }
      await new SeaImportJob(siJob).loadJobRelated({
        job: true,
        seaEQ: true,
        lclSlaves: this._view.masterFlag,
        charges: true,
        warehouseIn: this._view.masterFlag,
        warehouseInfo: true,
        trucking: true,
        lclMaster: !this._view.masterFlag,
        seaCargoDoc: !this._view.masterFlag,
        containerUsages: true,
        containers: true,
        surchargeTerms: !this._view.masterFlag
      })
      this._view.job = siJob
      return
    }
    if (this._view.lob === 'AE') {
      const aeJob = { uuid: this._view.jobUuid }
      await new AirExportJob(aeJob).loadJobRelated({
        job: true,
        cargoDoc: true,
        airCargoDoc: true,
        lclSlaves: this._view.masterFlag,
        charges: true,
        warehouseIn: this._view.masterFlag,
        warehouseInfo: true,
        trucking: true,
        lclMaster: !this._view.masterFlag,
        containerUsages: true,
        containers: true
      })
      this._view.job = aeJob
      return
    }
    if (this._view.lob === 'AI') {
      const aiJob = { uuid: this._view.jobUuid }
      await new AirImportJob(aiJob).loadJobRelated({
        job: true,
        masterJob: !this._view.masterFlag,
        lclSlaves: this._view.masterFlag
      })
      this._view.job = aiJob
      return
    }
    if (this._view.lob === 'RE' || this._view.lob === 'RI') {
      const reJob = { uuid: this._view.jobUuid }
      await new RailwayExportJob(reJob).loadJobRelated({
        job: true,
        seaEQ: true,
        lclSlaves: this._view.masterFlag,
        lclMaster: !this._view.masterFlag,
        charges: true,
        warehouseIn: true,
        warehouseInfo: true,
        trucking: true,
        containerUsages: true,
        containers: true,
        cargoBulkDetail: !this._view.masterFlag,
        surchargeTerms: !this._view.masterFlag
      })
      this._view.job = reJob
      return
    }
    let requestApi = null
    let JobClazz = null
    switch (this._view.lob) {
      /* case 'AE':
        requestApi = getAeJobDetail
        JobClazz = AirExportJob
        break
      case 'AI':
        requestApi = getAiJobDetail
        JobClazz = AirImportJob
        break*/
      case 'SI':
        requestApi = getSiJobDetail
        JobClazz = SeaImportJob
        break
      case 'RE':
      case 'RI':
        requestApi = getReJobDetail
        JobClazz = RailwayExportJob
        break
    }
    if (requestApi) {
      await requestApi(this._view.jobUuid).then(async res => {
        // todo ceshi
        let job = {}
        if (this._view.masterFlag) {
          job = { ...res.data.master, lclSlaves: [...res.data.lclSlaves], seaEQ: [... res.data.seaEqVOList] }
        } else {
          job = { ...res.data.lclSlaves[0], master: { ...res.data.master }, lclSlaves: [], seaEQ: [... res.data.seaEqVOList] }
        }
        if (this._view.lob === 'RE' || this._view.lob === 'RI') {
          const reJob = { uuid: this._view.jobUuid }
          await new RailwayExportJob(reJob).loadJobRelated({
            job: true,
            seaEQ: true,
            lclSlaves: this._view.masterFlag,
            lclMaster: !this._view.masterFlag,
            charges: this._view.masterFlag,
            warehouseIn: this._view.masterFlag,
            warehouseInfo: this._view.masterFlag,
            trucking: this._view.masterFlag,
            seaCargoDoc: !this._view.masterFlag,
            containerUsages: !this._view.masterFlag,
            containers: !this._view.masterFlag,
            cargoBulkDetail: !this._view.masterFlag,
            surchargeTerms: !this._view.masterFlag
          })
          Object.assign(this._view.job, reJob)
          return
        }
        this._view.job = new JobClazz(job).fillDefaultValue().getData()
      })
    }
  }
  // 导出全部
  async exportExcelAllClickHandler() {
    this._view.$emit('exportAll2Excel', 'detail')
  }
  // 业务调整
  buissInfoClickHandler() {
    // todo
    this.cABtnGroupView.showBusinessAdjustDialog = true
  }
  buissInfoClickHandlerConfirmCB() {
    this.refresh()
  }
  refresh() {
    // todo job状态变更后，进行异步刷新
    this._view.showDetail(this._view.job)
    // todo 定位到当前页签
  }
  // 修改费用财务日期
  async updateChargeAccountingDateClickHandler() {
    // 获取 选中的费用记录
    const chooseCharges = this._view.$refs['tabCharges'].tabChargesHP.getAllSelectedRows(false)
    if (!chooseCharges || chooseCharges.length <= 0) {
      this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExpense'))
      return
    }
    this.cABtnGroupView.showUpdateChargeAccountingDateDialog = true
  }
  async updateChargeAccountingDateConfirmCB(accountingDate) {
    // todo 修改选中费用的 财务日期 --- 可以结合修改财务日期的逻辑一起处理
    // await this.$confirm('确定要修改单笔费用财务日期吗？', '提示')
    this.$confirm(this.$t('Message.FinancialDateOfASingleExpense'), this.$t('common.tips.prompt'), {
      confirmButtonText: this.$t('common.btn.yes'),
      cancelButtonText: this.$t('common.btn.no'),
      type: 'warning'
    }).then(() => {
      const chooseCharges = this._view.$refs['tabCharges'].tabChargesHP.getAllSelectedRows(false)
      const chargeUuids = chooseCharges.map(item => item.uuid)
      this.loading()
      batchUpdateChargeAccountingDate(chargeUuids, accountingDate, this._view.location).then(res => {
        this.$message.success(this.$t('Message.ExpenseFinancialDateModifiedSuccessfully'))
        this.cABtnGroupView.showUpdateChargeAccountingDateDialog = false
        this.refresh()
      }).finally(() => {
        this.closeLoading()
      })
    }).catch(() => {
    })
  }
  // 修改财务日期
  async updateAccountingDateClickHandler() {
    this.cABtnGroupView.showUpdateAccountingDateDialog = true
  }
  async updateAccountingDateConfirmCB(accountingDate) {
    this.cABtnGroupView.accountingPageDate = new Date(accountingDate)
    await this.$confirm(this.$t('Message.ModifyTheFinancialDate'), this.$t('common.tips.prompt'), { type: 'warning' })
    const job = this.cABtnGroupView.job
    // todo 主票或下票关联的费用的日期全部更改为 accountingDate（需要判断是否关账） 放到后台处理
    this.loading()
    batchUpdateAccountingDate([job.uuid], accountingDate, this._view.location).then(res => {
      this.$message.success(this.$t('Message.FinancialDateModifiedSuccessfully'))
      this.cABtnGroupView.showUpdateAccountingDateDialog = false
      this.refresh()
    }).finally(() => {
      this.closeLoading()
    })
  }
  async cancelAccountingDate(pageDate) {
    this.cABtnGroupView.accountingPageDate = new Date(pageDate)
  }

  // 计提
  async provisionedClickHandler() {
    const list = [this.cABtnGroupView.job]
    await this.updateProvisionedStateClickHandler(list, 1)
    this.cABtnGroupView.showProvisionedDialog = true
  }

  /**
   * 计提弹框确认回调
   * @param provisionedDate
   * @returns {Promise<void>}
   */
  async provisionedConfirmCB(provisionedDate) {
    this.loading()
    await this.updateProvisionedConfirmCB([this.cABtnGroupView.job.uuid], provisionedDate, this.cABtnGroupView.job.clearingDateSql, this._view.location).then(res => {
      this.cABtnGroupView.showProvisionedDialog = false
      // this.$message.success('计提成功')
      this.refresh()
    }).finally(() => {
      this.closeLoading()
    })
  }

  // 核对审核日期
  async checkAccountDate(accountDate) {
    const job = this.cABtnGroupView.job
    await this.$confirm(new Date(job.businessDate) > accountDate ? this.$t('Message.ApprovalDateIsEarlierThanBusinessDate') : this.$t('Message.AreYouSureToReviewTheseLists'), this.$t('common.tips.prompt'), { type: 'warning' })
  }
  /* 改单审核*/
  checkChangeClickHandler() {
    if (this.cABtnGroupView.job.changeState !== SystemConstants.CHANGE_COMMIT.code) {
      this.$message.warning(this.$t('Message.ThisBusinessIsNotApproved', [SystemConstants.CHANGE_COMMIT.chineseName]))
      return
    }
    this.cABtnGroupView.showChangeDialog = true
  }

  /**
   * 撤回改单提交
   */
  async btnRevokeChangeCommit_clickHandler() {
    if (this.cABtnGroupView.job.changeState !== SystemConstants.CHANGE_COMMIT.code) {
      this.$message.warning(this.$t('Message.ThisBusinessIsNotApproved2', [SystemConstants.CHANGE_COMMIT.chineseName]))
      return
    }
    await this.$confirm(this.$t('Message.TheDocumentChangeSubmission'), this.$t('common.tips.prompt'), { type: 'warning' })
    Job.updateChangeState([this.cABtnGroupView.job.uuid], { changeState: SystemConstants.CHANGE_REVOKE_COMMIT.code, branchId: this.$store.getters.currentOfficeId, accountingDate: null, location: this._view.location }).then(res => {
      this.$message.success(this.$t('Message.AllowToChangeTheOrderSuccessfully'))
      this.refresh()
    }).finally(() => {
      this.closeLoading()
    })
  }
  async allowChangeClickHandler() {
    this.$confirm(this.$t('Message.AllowOrderChange'), this.$t('common.tips.prompt'), { type: 'warning' }).then(() => {
      this.loading()
      Job.updateChangeState([this.cABtnGroupView.job.uuid], { changeState: SystemConstants.CHANGE_CANCHANGE.code, branchId: this.$store.getters.currentOfficeId, accountingDate: null, location: this._view.location }).then(res => {
        this.$message.success(this.$t('Message.AllowToChangeTheOrderSuccessfully'))
        this.refresh()
      }).finally(() => {
        this.closeLoading()
      })
    })
  }
  // 取消费用审核
  async cancelChargesAuditClickHandler() {
    const items = this._getSelectCharges(1)
    await Assert.isTrue(items.length > 0, this.$t('Message.NoExpenseSelectedOrNotInApprovalStatus'), 'warning')

    await this.$confirm(this.$t('CargoMsg.Cargo_SureToCancelVerification'), this.$t('common.tips.prompt'), { type: 'warning' })

    const uuidAccountDateMap = {}
    for (const charge of items) {
      charge.chargeState = 2
      // todo 使用job对象model
      if (this.cABtnGroupView.job.jobState < 2 || this.job.jobState === 13) {
        charge.accountingDate = null
      }
      uuidAccountDateMap[charge.uuid] = charge.accountingDate
      if (Object.prototype.hasOwnProperty.call(uuidAccountDateMap, 'jobUuid')) continue
      uuidAccountDateMap['jobUuid'] = charge.jobUuid
    }
    uuidAccountDateMap['location'] = this._view.location
    this.loading()
    batchUpdateChargeState(uuidAccountDateMap, 1).then(res => {
      this.$message.success(this.$t('Message.ExpenseStatusUpdatedSuccessfully'))
      this.refresh()
    }).finally(() => {
      this.closeLoading()
    })
    // todo 标记的操作来源node
    // Session.getInstance().clazzAndFunctionName(this, arguments.callee, 'btnChargeAuditCancelClickHandler'))
  }
  /* 费用审核*/
  async chargeAuditClickHandler() {
    const items = this._getSelectCharges(2)
    await Assert.isTrue(items.length > 0, this.$t('Message.ChargeIsNotSelectedOrNotInTheSubmissionStatus'), 'warning')
    this.cABtnGroupView.showChargeCheckDialog = true
  }

  /**
   * 费用审核回调
   * @param checkDate
   */
  chargeAuditConfirmCB(accountingDate) {
    const items = this._getSelectCharges(2)

    const uuidAccountDateMap = {}
    for (const charge of items) {
      charge.chargeState = 2
      //
      if (!charge.accountingDate) {
        charge.accountingDate = accountingDate
      }
      uuidAccountDateMap[charge.uuid] = charge.accountingDate
      if (Object.prototype.hasOwnProperty.call(uuidAccountDateMap, 'jobUuid')) continue
      uuidAccountDateMap['jobUuid'] = charge.jobUuid
    }
    uuidAccountDateMap['location'] = this._view.location
    batchUpdateChargeState(uuidAccountDateMap, 2).then(res => {
      this.$message.success(this.$t('Message.ExpenseStatusUpdatedSuccessfully'))

      this.refresh()
      this.cABtnGroupView.showChargeCheckDialog = false
    })
    // todo 标记的操作来源node
    // Session.getInstance().clazzAndFunctionName(this, arguments.callee, 'chargeAccountDateCallBackHandler'))
  }

  /**
   * 获取选中费用
   */
  _getSelectCharges(chargeState) {
    const items = []
    if (!this._view || !this._view.$refs['tabCharges'] || this._view.$refs['tabCharges'] === undefined) {
      if (chargeState === 1) {
        this.$message.warning(this.$t('Message.NoExpenseSelectedOrNotInApprovalStatus'))
      } else {
        this.$message.warning(this.$t('Message.ChargeIsNotSelectedOrNotInTheSubmissionStatus'))
      }
      return
    }
    const chooseCharges = this._view.$refs['tabCharges'].tabChargesHP.getAllSelectedRows(false)
    for (const charge of chooseCharges) {
      if (chargeState === 2 ? charge.chargeState === 1 : charge.chargeState === 2) {
        items.push(charge)
      }
    }
    return items
  }
  // 取消财务审核
  async cancelAuditClickHandler() {
    await this.$confirm(this.$t('Message.AreYouSureYouWantToCancelTheApproval'), this.$t('common.tips.prompt'), { type: 'warning' })
    Job.jobClosingAccountRollbackHandler([this.cABtnGroupView.job.uuid], this._view.location).then(res => {
      this.$message.success(this.$t('CargoMsg.Cargo_ReviewCancelledSuccessfully'))
      this.refresh()
    })
  }
  // 审核
  async auditClickHandler() {
    if (this.cABtnGroupView.job.lclMasterUuid && this.allSubmitFcl) {
      this.$message.warning(this.$t('Message.LCLTicketsCannotBeReviewedSeparately'))
      return
    }
    await cache.load(cacheName.CONFIG)
    this.cABtnGroupView.editApprovalDate = Number(cache.config.get('isAllowEditApprovalDate')) === 1
    // const hasCheckRule = await JobUtils.hasCheckRuleCondition(this.useCheckRule, 13, this.cABtnGroupView.job.opOffice)
    const hasCheckRule = true
    if (this._view.cADetailHp.useCheckRule && hasCheckRule) {
      this.cABtnGroupView.showCheckDialog = false
      const callBack = this.showcABtnGroupViewCall
      const callBack2 = null
      this.checkingManager(13, callBack, callBack2)
    } else {
      this.showcABtnGroupView()
    }
  }
  showcABtnGroupViewCall() {
    return true
  }
  showcABtnGroupView() {
    this.cABtnGroupView.checkDialog.poNo = this.cABtnGroupView.job.poNo
    this.cABtnGroupView.checkDialog.isEditable = false
    this.cABtnGroupView.showCheckDialog = true
  }

  async batchCheckChangeConfirmCB(accountDate) {
    await super.batchCheckChangeConfirmCB([this.cABtnGroupView.job.uuid], accountDate)
  }
  async batchAuditConfirmCB({ accountDate, poNo }) {
    await super.batchAuditConfirmCB([this.cABtnGroupView.job.uuid], accountDate, poNo, this.cABtnGroupView.job.invoiceDateSql)
  }

  async batchAuditConfirmSuccessCB() {
    this.$message.success(this.$t('Clearing.ReviewSuccess'))
  }

  async batchAuditConfirmFailCB() {
    this.$message.warning(this.$t('Clearing.ReviewFailed'))
  }
  updateResultProvisioned() {
    //

  }
  updateDefaultMenuState() {
    // 在 btnGroup.vue中实现
    this.refresh()
  }
  async beforeMount() {
    await super.beforeMount()
  }

  /**
   * 单个计提（详情使用，可todo del）
   *
   */
  btnIsProvisionedClickHandler() {

  }

  created() {
    this._view.gridOptions = {
      rowSelection: 'multiple',
      treeData: true,
      groupDefaultExpanded: 2,
      getDataPath: data => {
        return data.path.split(',')
      },
      autoGroupColumnDef: {
        headerName: this.$t('CargoMsg.Cargo_BusinessNo'),
        field: 'jobNo',
        width: 160,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        cellRendererParams: {
          suppressCount: true,
          suppressDoubleClickExpand: false,
          checkbox: params => {
            return false
          },
          innerRenderer: params => {
            return params.value
          }
        }
      },
      onCellClicked: event => {
        this._view.selectedJob = event.data
        if (!this._view.selectedJob) {
          this._view.selectedJob = this.readSelectedRows()[0]
        }
      },
      onCellFocused: this._view.handleCellFocused
    }
  }

  // 打印
  printHandler() {
    if (this._view.job.blocked) {
      this.$message.info(this._view.job.jobNo + this.$t('Message.ItIsLocked'))
      return
    }
    if (this._view.activeTabName !== 'tabInternalBill' && this._view.activeTabName !== 'tabOverseaBill') {
      // printChecked
      const params = {}
      let category = ''
      if (this._view.job.lob === 'SE') {
        category = 'BOOKING'
      } else if (this._view.job.lob === 'SI') {
        category = 'SIJOBNO'
      } else if (this._view.job.lob === 'AE') {
        category = 'AEBOOKING'
      } else {
        category = 'AIJOBNO'
      }
      params.jobuuid = this._view.job.uuid
      params.JOB_UUID = this._view.job.uuid
      // TemplateSelectorWin.getInstance().showThisWin(_job, category, params, this)
      this._view.templateSelectorDialog.cxt = this._view.job
      this._view.templateSelectorDialog.category = category
      this._view.templateSelectorDialog.data = params
      this._view.templateSelectorDialog.visible = true
      return
    }
    this.$nextTick(async() => {
      // 每个页签的参数
      const params = await this.$refs[this._view.activeTabName].getPrintData() || null
      if (!params) return
      // 公共参数
      if (!Object.prototype.hasOwnProperty.call(params, 'jobuuid') || !params.jobuuid) {
        params.jobuuid = this._view.job.uuid
      }
      if (!Object.prototype.hasOwnProperty.call(params, 'JOB_UUID') || !params.JOB_UUID) {
        params.JOB_UUID = this._view.job.uuid
      }
      console.log('---params--', params)
      this._view.templateSelectorDialog.ctx = Object.prototype.hasOwnProperty.call(params, 'ctx') ? params.ctx : null
      if (Object.prototype.hasOwnProperty(params, 'ctx')) delete params.ctx
      this._view.templateSelectorDialog.category = params.category
      this._view.templateSelectorDialog.data = params
      // 组装打印回调函数
      await this._view.onPrintCallback(params)
      this._view.templateSelectorDialog.visible = true
    })
  }
  /**
   * 利润打印
   * @public
   */
  async profitPrintClickHandler() {
    if (this._view.job.lob === 'SE') {
      const exportJob = this._view.job
      // 整箱
      if (exportJob != null && !exportJob.masterFlag && (exportJob.containerLoadType === ContainerLoadType.FCL_CARGO_TYPE.code || exportJob.containerLoadType === ContainerLoadType.BB_CARGO_TYPE.code || exportJob.containerLoadType === ContainerLoadType.SPECIAL_CARGO_TYPE.code)) {
        await this.checkPrintEnable(this._view, this.doPrintFCLPROFIT)
      }
      // 拼箱主票
      if (exportJob !== null && exportJob.masterFlag) {
        await this.checkPrintEnable(this._view, this.doPrintLCLPROFIT)
      }
    } else if (this._view.job.lob === 'SI') {
      const importJob = this._view.job
      if (importJob != null && !importJob.masterFlag && (importJob.containerLoadType !== ContainerLoadType.LCL_CARGO_TYPE.code)) {
        // 整箱打印
        await this.checkPrintEnable(this._view, this.doPrintFCLPROFIT)
      } else {
        // 拼箱打印
        await this.checkPrintEnable(this._view, this.doPrintLCLPROFIT)
      }
    } else if (this._view.job.lob === 'AI') {
      await this.checkPrintEnable(this._view, this.doPrintAiImport)
    } else {
      await this.checkPrintEnable(this._view, this.doPrintAiExport)
    }
  }

  /**
   * 确认是否可打印
   */
  async checkPrintEnable(view, callback) {
    // 组装打印回调函数
    // await this._view.onPrintCallback()
    if (this._view.job && !this._view.job.masterFlag && Number(this._view.job.sales) <= 0 && this._view.job.cargoSource !== CargoSource.NC_CARGO_SOURCE.code) {
      this.$message.warning(this.$t('Message.PleaseInputTheSalesInformationAndPrints'))
    } else if (this._view.job && this._view.job.masterFlag) {
      if (this._view.job.uuid && this._view.job.lclSlaves === null) {
        this._view.job.lclSlaves = await new Job(this._view.job).getLclSlaves()
      }
      this.loadLclResult(callback, view)
    } else if (this._view.job && !this._view.job.masterFlag) {
      callback(view)
    }
  }
  /**
   * 整箱
   *  @private
   */
  doPrintFCLPROFIT(view) {
    const params = {}
    params.jobuuid = view.job.uuid
    params.JOB_UUID = view.job.uuid
    let category = ''
    if (view.job.lob === 'SI') {
      category = 'SIFCLPROFIT'
    } else {
      category = 'FCLPROFIT'
    }
    // TemplateSelectorWin.getInstance().showThisWin(_job, category, params, financeView, doPrintPROFIT);
    view.templateSelectorDialog.ctx = new Job(view.job)
    view.templateSelectorDialog.category = category
    view.templateSelectorDialog.data = params
    // 组装打印回调
    view.prePrintCallback = view.doPrintPROFIT
    view.templateSelectorDialog.visible = true
  }

  /**
   * 拼箱
   * @private
   */
  doPrintLCLPROFIT(view) {
    const params = {}
    params.jobuuid = view.job.uuid
    params.JOB_UUID = view.job.uuid
    // TemplateSelectorWin.getInstance().showThisWin(_job, "LCLPROFIT", params, financeView, doPrintPROFIT);
    view.templateSelectorDialog.ctx = new Job(view.job)
    view.templateSelectorDialog.category = 'LCLPROFIT'
    view.templateSelectorDialog.data = params
    // 组装打印回调
    view.prePrintCallback = view.doPrintPROFIT
    view.templateSelectorDialog.visible = true
  }

  doPrintAiImport(view) {
    const category = view.job.operateType === ImportConstants.CONSOLE.code ? 'AIPROFIT_PP' : 'AIPROFIT'
    // TemplateSelectorWin.getInstance().showThisWin(_job, category, {"JOB_UUID" : _job.key}, financeView, doPrintPROFIT);
    view.templateSelectorDialog.ctx = new Job(view.job)
    view.templateSelectorDialog.category = category
    view.templateSelectorDialog.data = { 'JOB_UUID': view.job.uuid, 'jobuuid': view.job.uuid }
    // 组装打印回调
    view.prePrintCallback = view.doPrintPROFIT
    view.templateSelectorDialog.visible = true
  }

  doPrintAiExport(view) {
    const category = view.job.operateType === AirExportConstants.CONSOLE.code ? 'AEPROFIT2' : 'AEPROFIT'
    // TemplateSelectorWin.getInstance().showThisWin(_job, category, {"JOB_UUID" : _job.key}, financeView, doPrintPROFIT);
    view.templateSelectorDialog.ctx = new Job(view.job)
    view.templateSelectorDialog.category = category
    view.templateSelectorDialog.data = { 'JOB_UUID': view.job.uuid, 'jobuuid': view.job.uuid }
    // 组装打印回调
    view.prePrintCallback = view.doPrintPROFIT
    view.templateSelectorDialog.visible = true
  }
  /**
   * 加载用量成功
   */
  loadLclResult(callback, view) {
    const jobNos = []
    if (this._view.job.lclSlaves != null && this._view.job.lclSlaves.length > 0) {
      for (const job of this._view.job.lclSlaves) {
        if (job.sales <= 0 && job.cargoSource !== CargoSource.NC_CARGO_SOURCE.code) {
          jobNos.push(job.jobNo)
        }
      }
      if (jobNos.length > 0) {
        this.$message.warning(this.$t('Message.FollowingTheSingleDidNotEnterTheSalesInformation') + '：\n' + jobNos.join('\n') + '\n' + this.$t('Message.PleaseEnterAndPrint'))
      } else {
        callback(view)
      }
    }
  }
  // 验证规则配置公用
  checkingManager(checkNode, callBack, callBack2) {
    if (!this.cABtnGroupView.job) return
    this.cABtnGroupView.checkingWindow.job = this.cABtnGroupView.job
    this.cABtnGroupView.checkingWindow.callBack = callBack
    this.cABtnGroupView.checkingWindow.callBack2 = callBack2
    this.cABtnGroupView.checkingWindow.visible = true
  }
}
